import { render, staticRenderFns } from "./CourseItemEdit.vue?vue&type=template&id=e3846322&scoped=true&"
import script from "./CourseItemEdit.vue?vue&type=script&lang=js&"
export * from "./CourseItemEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3846322",
  null
  
)

export default component.exports